import React from "react";
import { Map } from "lucide-react";
import { useSelector } from "react-redux";
import { formatCylinderChangeExcelData } from "../../utils/excelFormatters";
import { siteCylinderChangeFilteroptions } from "../../utils/complaintFilter.config";
import FilterSearch from "../../../../components/common/FilterSearch";

export const TABLE_SEARCH = {
  id: ["stationName"],
  station: ["stationId"],
};

export const SummaryCards = () => {
  const originalData = useSelector((state) => state.data.copyData);
  const TotalSites = originalData.length;
  // ...............get  excel data............
  const excelData = formatCylinderChangeExcelData(originalData);
  const excelConfig = {
    data: excelData,
    fileName: "Visit_Cylinders_Change_Report",
    sheetName: "Visits",
  };

  return (
    <div className="flex gap-2 mt-2">
      <div className="white-card w-[30%]">
        {/* Icon */}
        <div className={`p-2 rounded-md bg-blue-2`}>
          <Map className="text-[#2e45a8]" />
        </div>

        {/* Content */}
        <div>
          <h3 className={`text-[#2e45a8] text-xl font-bold`}>{TotalSites}</h3>
          <p className="text-xs lg:text-[14px] font-figtreeMedium text-[#6b7aab]">
            Total Visits
          </p>
        </div>
      </div>
      <div className="white-card w-full">
        <FilterSearch
          categories={siteCylinderChangeFilteroptions}
          searchCategories={TABLE_SEARCH}
          excelConfig={excelConfig}
        />
      </div>
    </div>
  );
};
